<template>
    <div>
        <TableInformation1 :leftDescriptionTable="leftDescriptionTable" :rightDescriptionTable="rightDescriptionTable"></TableInformation1>
        <div class="table-responsive mb-5">
            <table class="table table-sm table-bordered table-striped table-hover">
                <thead>
                    <tr>
                        <th scope="col" class="text-center font-weight-bold">No</th>
                        <th v-if="[1,3,5].includes(data?.status)" scope="col" class="text-center font-weight-bold">ACTION</th>
                        <th scope="col" class="text-center font-weight-bold">MATERIAL</th>
                        <th scope="col" class="text-center font-weight-bold">DESCRIPTION</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">ABC Indicator</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">Reorder Point</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">Maximum</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">LAST UPDATE</th>
                        <th scope="col" class="text-center font-weight-bold bg-light-yellow">ABC Indicator</th>
                        <th scope="col" class="text-center font-weight-bold bg-light-yellow">Reorder Point</th>
                        <th scope="col" class="text-center font-weight-bold bg-light-yellow">Maximum</th>
                        <th scope="col" class="text-center font-weight-bold bg-purple">ABC Indicator</th>
                        <th scope="col" class="text-center font-weight-bold bg-purple">Reorder Point</th>
                        <th scope="col" class="text-center font-weight-bold bg-purple">Maximum</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">UPDATE AT</th>
                    </tr>
                </thead>
                <tbody v-for="(item, index) in items" :key="index">
                    <tr>
                        <th scope="row" class="py-2 text-center">{{ index + 1 }}</th>
                        <td v-if="[1,3,5].includes(data?.status)" class="text-center py-2"><span class="badge badge-pill btn-danger cursor-pointer" @click="delete_item(item?.id)">Delete</span></td>
                        <td class="text-center py-2">{{ item?.material_code }}</td>
                        <td class="py-2">{{ item?.material_description }}</td>
                        <td class="text-center py-2">{{ item?.abc_indicator }}</td>
                        <td class="text-center py-2">{{ item?.rop }}</td>
                        <td class="text-center py-2">{{ item?.eoq }}</td>
                        <td class="text-center py-2">{{ '02 Januari 2025' }}</td>
                        <td class="text-center py-2">{{ item?.abc_indicator_calculate }}</td>
                        <td class="text-center py-2">{{ item?.rop_calculate }}</td>
                        <td class="text-center py-2">{{ item?.eoq_calculate }}</td>
                        <td class="text-center py-2">{{ item?.abc_indicator_result }}</td>
                        <td class="text-center py-2">{{ item?.rop_result }}</td>
                        <td class="text-center py-2">{{ item?.eoq_result }}</td>
                        <td class="text-center py-2">{{ '02 Januari 2025' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import TableInformation1 from './TableInformation1.vue';
import Swal from "sweetalert2";
import Api from '@/helpers/api';
import stockCalcService from '@/services/material/stockCalculation.service';

export default {
    name: 'StockCalcSumaryTable',
    components: {
        TableInformation1
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        data: {
            required: true
        }
    },
    data() {
        return {
            leftDescriptionTable: [{lable: 'Existing', bg: 'bg-grey'},{lable: 'Calculator Recomendation', bg: 'bg-light-yellow'}, {lable: 'Update', bg: 'bg-purple'}],
            rightDescriptionTable: [{lable: 'Yes', bg: 'bg-light-green'},{lable: 'No', bg: 'bg-light-red'}, {lable: 'Other', bg: 'bg-light-blue'}]
        }
    },
    methods: {
        formatTanggal(value) {
            if (!value) return '-';
            return moment(value).format('D MMMM YYYY');
        },
        delete_item(id) {
             Swal.fire({
                title: "Confirmation",
                html: "Apakah Anda yakin?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#5e72e4",
                cancelButtonColor: "#f5365c",
                confirmButtonText: "Yes",
                heightAuto: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$emit('is-delete-item', true)
                    Api(this, stockCalcService.delete_item(this.data.id, id))
                        .onSuccess((response) => {
                            Swal.fire({
                                title: 'Sukses!',
                                text: 'Item berhasil dihapus.',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                        })
                        .onError((error) => {
                            const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                            this.$notify({
                                message: errorMessage,
                                type: 'danger',
                                verticalAlign: "bottom",
                                horizontalAlign: "left"
                            });
                        })
                        .onFinish(() => {
                            this.$emit('is-delete-item', false)
                        })
                        .call()
                }
            })
        }
    }
}
</script>